module.exports = __webpack_public_path__ + "img/packages/2.823f0c.png";